import { useEffect, useMemo, useRef } from 'react';
import { AbortType } from '@cb/common-ts/FetchClient';
export default function useCancelRegistry() {
    const registry = useRef([]);
    const registerCancel = useMemo(() => (cancel) => {
        registry.current.push(cancel);
        return () => {
            registry.current = registry.current.filter((c) => c !== cancel);
        };
    }, []);
    useEffect(() => {
        return () => {
            registry.current.forEach((cancel) => cancel(AbortType.UNMOUNT));
        };
    }, []);
    return registerCancel;
}
//# sourceMappingURL=UseCancelRegistry.js.map